export enum CareerLevel {
	STUDENT = 'Student',
	ENTRY_LEVEL = 'Entry Level',
	JUNIOR = 'Junior',
	MIDLEVEL = 'Mid-Level',
	SENIOR = 'Senior',
	TEAM_LEAD = 'Team Lead',
	MANAGER = 'Manager'
}
